export default {
    en: {
        economie_1: 'Estimated interest saved during the ',
        economie_2: ' term',
        tooltipEconomie_1:
            'Depending on the term selected, your actual savings will depend on a number of factors, including any rate changes, prepayments or late payments.',
        tooltipEconomie_2: '',
        economieInteret: 'd’économie d’intérêt'
    },
    fr: {
        economie_1: 'Économie d’intérêt estimé durant le terme de ',
        economie_2: '',
        tooltipEconomie_1:
            'Selon le terme choisi, cette économie pourrait varier en fonction de différents facteurs.',
        tooltipEconomie_2:
            'Exemples : fluctuation du taux, remboursements anticipés, retards de paiement.',
        economieInteret: 'd’économie d’intérêt'
    }
};
